import { useState } from "react";

import QuestionsCarousel from "./Carusel";
import QuestionsList from "./List";

export const PageSize = 20;

function QuestionsView({
	viewType,
	data,
	page,
	setPage,
	count,
	isLoading,
	searchValue,
	scrollToTop,
	defaultSettings = undefined,
	emptyState,
	revealAnswers = false,
}) {
	const [answers, setAnswers] = useState([]);

	const setUserAnswer = (answer) => {
		setAnswers([...answers, answer]);
	};

	if (data && data.length === 0) {
		return emptyState;
	}

	// wyłączone zapytanie (np. czeka na drzewo działów po odświeżeniu) = idle, nie loading — bez danych też szkielet
	const isPending = isLoading || !data;

	const getQuestionsWithAnswers = () => {
		if (!data) {
			return null;
		}

		const answersObject = answers.reduce((acc, { questionId, answer }) => {
			acc[questionId] = answer;

			return acc;
		}, {});

		return data.map((question) => {
			return {
				...question,
				answer:
					answersObject[question.id] ||
					(revealAnswers ? question.correctAnswer : null),
			};
		});
	};

	if (viewType === "list") {
		return (
			<QuestionsList
				data={getQuestionsWithAnswers()}
				page={page}
				setPage={setPage}
				count={Math.ceil(count / PageSize)}
				answers={answers}
				setAnswer={setUserAnswer}
				isLoading={isPending}
				searchValue={searchValue}
				scrollToTop={scrollToTop}
				defaultSettings={defaultSettings}
			/>
		);
	}

	return (
		<QuestionsCarousel
			data={getQuestionsWithAnswers()}
			page={page}
			setPage={setPage}
			count={count}
			answers={answers}
			setAnswer={setUserAnswer}
			isLoading={isPending}
			searchValue={searchValue}
			defaultSettings={defaultSettings}
		/>
	);
}

export default QuestionsView;
